import React from 'react';
import _ from 'lodash';
import EmailSettingsComponent from './email-settings-component';
import hasRESTClient from '../../hocs/has-rest-client';

const RESTRICTED_CORQ_DOMAINS = [
  'data.corq.studio',
  'corq.dyzio.co',
];

class CampaignEmailSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...props };
  }

  onPermissionChange = ({ id, key, value }) => {
    const { restClient } = this.props;
    const { teamMembers } = this.state;
    const newTeamMembers = _.map(teamMembers,
      member => (member.id === id ? { ...member, [key]: value } : member),
    );
    restClient.patch(`campaignPermission/${id}`, {
      data: {
        attributes: {
          [key]: value,
        },
      },
    });
    return this.setState({ teamMembers: newTeamMembers });
  }

  render = () => {
    const { host } = window.location;
    const isCorq = _.includes(RESTRICTED_CORQ_DOMAINS, host);

    return (
      <EmailSettingsComponent
        {...this.props}
        showManageLink={!isCorq}
        onPermissionChange={this.onPermissionChange}
      />
    );
  }
}

export default hasRESTClient(CampaignEmailSettings);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-email-settings/index.js
 **/